import { reflectionSpots } from '@/mocks/home';

export default function ReflectionFeature() {
  const [lead, ...others] = reflectionSpots;

  return (
    <section id="reflection" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-2xl mb-10">
          <div className="text-[11px] tracking-[0.3em] text-secondary-700 mb-3">反光专题</div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            玻璃与镜面，会替你多拍一个角度
          </h2>
          <p className="text-sm md:text-base leading-relaxed text-foreground-600">
            窗面、镜面、车漆上的倒影常被忽略，却往往能补上背景与位置的两块拼图。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <a
            href="#entry"
            className="group lg:col-span-7 flex flex-col rounded-lg overflow-hidden border border-background-200/70 bg-background-100 cursor-pointer transition-colors hover:border-primary-300"
          >
            <div className="w-full h-[260px] md:h-[380px] overflow-hidden bg-background-200">
              <img
                src={lead.image}
                alt="私拍吃瓜反光 专题配图"
                title="私拍吃瓜反光 倒影细节"
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
            </div>
            <div className="p-6">
              <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-900 text-[11px] tracking-wider mb-4">
                {lead.tag}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
                {lead.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{lead.desc}</p>
            </div>
          </a>

          <div className="lg:col-span-5 flex flex-col gap-6">
            {others.map((spot) => (
              <a
                key={spot.id}
                href="#entry"
                className="group flex flex-col sm:flex-row lg:flex-col rounded-lg overflow-hidden border border-background-200/70 bg-background-100 cursor-pointer transition-colors hover:border-primary-300"
              >
                <div className="w-full sm:w-[45%] lg:w-full h-[180px] lg:h-[160px] overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={spot.image}
                    alt={`私拍吃瓜反光 ${spot.tag}`}
                    title={`私拍吃瓜反光 ${spot.tag} 细节`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-5 flex-1">
                  <span className="inline-block px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px] tracking-wider mb-3">
                    {spot.tag}
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">
                    {spot.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{spot.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}